import { createFileRoute } from '@tanstack/react-router';
import { PrintShell, PrintSong } from '@/components/ui/cifras/print-sheet';
import { Content } from '@/components/ui/content';
import { useRouter } from '@/hooks/use-router';
import { meta } from '@/lib/meta';
import { useSong } from '@/services/songs';

export const Route = createFileRoute('/_app/songs/$id/print')({
  head: () => meta({ label: 'Imprimir cifra' }),
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const router = useRouter();
  const { data } = useSong({ id });

  return (
    <Content
      isLoading={!data}
      breadcrumbs={{
        icon: 'printer',
        title: data?.title ?? 'Imprimir',
        items: [
          { label: 'Cifras', route: '/songs' },
          { label: 'Impressão', active: true },
        ],
      }}
    >
      <PrintShell onBack={() => router.back()}>
        {(options) =>
          data && (
            <PrintSong
              {...options}
              song={{
                id: data.id,
                title: data.title,
                originalKey: data.originalKey,
                capo: data.capo,
                notes: data.notes,
                content: data.content,
                artist: data.artist?.name ?? null,
                key: null,
              }}
            />
          )
        }
      </PrintShell>
    </Content>
  );
}
